import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import {
  Button,
  ButtonIcon,
  ButtonGroup,
  Slider,
  Toggle,
  Grid,
} from '@statsbomb/kitbag-components';
import Tile from '../../../components/Tile/Tile';
import { TeamPlusMinusControls } from './TeamPlusMinus.styles';
import {
  PLUS_MINUS_CATEGORIES,
  PLUS_MINUS_CATEGORY_NAMES,
} from './TeamPlusMinus.constants';
import {
  KitbagPageGridHolder,
  SidebarRightLayout,
} from '../../../components/Layout/Layout.styles';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { PAGE_HEADER_DISPLAY } from '../../../components/PageHeader/PageHeader.constants';

const TeamPlusMinus = () => {
  const [offense, setOffense] = useState(true);
  const [category, setCategory] = useState(PLUS_MINUS_CATEGORIES.TOTAL);
  const [minPlays, setMinPlays] = useState(10);
  const [minimumSnaps, setMinimumSnaps] = useState(minPlays);
  const [onOffDifference, setOnOffDifference] = useState(true);
  const [colorMinMax, setColorMinMax] = useState(true);

  return (
    <KitbagPageGridHolder>
      <Grid container={false} page>
        <Grid item xs={12}>
          <SidebarRightLayout
            $sidebarWidth="500px"
            $gap="0.5rem"
            $padding="0 0.25rem 0 0"
          >
            <div>
              <PageHeader
                href="/team/overview/:leagues/:seasons/:teams/"
                rootPage="Team"
                activePage="Player +/-"
                titleType={PAGE_HEADER_DISPLAY.TEAM}
              >
                <div className="buttons">
                  <CSVLink data={[]} filename="">
                    <ButtonIcon
                      size="small"
                      variant="secondary"
                      icon="Download"
                      disabled={false}
                      title="Download Player +/- Table"
                    >
                      download player +/- table
                    </ButtonIcon>
                  </CSVLink>
                </div>
              </PageHeader>
              <Tile border="0" margin="0.5rem 0 0 0">
                <Tile.Header>
                  <TeamPlusMinusControls>
                    <ButtonGroup>
                      <Button
                        size="small"
                        onClick={() => setOffense(true)}
                        variant={offense ? 'primary' : 'ghost'}
                      >
                        Offense
                      </Button>
                      <Button
                        size="small"
                        onClick={() => setOffense(false)}
                        variant={offense ? 'ghost' : 'primary'}
                      >
                        Defense
                      </Button>
                    </ButtonGroup>
                    <ButtonGroup>
                      {Object.values(PLUS_MINUS_CATEGORIES).map((c) => (
                        <Button
                          key={c}
                          size="small"
                          onClick={() => setCategory(c)}
                          variant={category === c ? 'primary' : 'ghost'}
                        >
                          {PLUS_MINUS_CATEGORY_NAMES[c]}
                        </Button>
                      ))}
                    </ButtonGroup>
                  </TeamPlusMinusControls>
                </Tile.Header>
              </Tile>
            </div>
            <div>
              <Tile margin="0" border="0">
                <Tile.Header>Display Options</Tile.Header>
                <Tile.Body>
                  <div>
                    <Slider
                      ariaLabel="minimum-snaps-filter"
                      max={200}
                      min={0}
                      step={10}
                      title="Minimum Total Snaps"
                      value={minimumSnaps}
                      onAfterChange={setMinPlays}
                      onChange={setMinimumSnaps}
                      reverse
                    />
                  </div>
                  <Toggle
                    id="on-off-difference-toggle"
                    label="On/Off Difference"
                    checked={onOffDifference}
                    onChange={() => setOnOffDifference(!onOffDifference)}
                  />
                  <Toggle
                    id="export-logo-toggle"
                    label="Color Gradient Team Min/Max"
                    checked={colorMinMax}
                    onChange={() => setColorMinMax(!colorMinMax)}
                  />
                </Tile.Body>
              </Tile>
            </div>
          </SidebarRightLayout>
        </Grid>
      </Grid>
    </KitbagPageGridHolder>
  );
};

export default TeamPlusMinus;
